var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconNoResults = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "85px",
    height: "72px",
    viewBox: "0 0 85 72",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Grphics/No result") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "App-Store-Public-User",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "RDH-Public---No-search-results",
    transform: "translate(-815.000000, -355.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(807.251534, 341.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8162132,51.6436129 C91.360271,62.7428782 82.2388226,67.0152341 73.6125274,71.6429119 C68.2587244,74.1518576 62.9049215,76.6751782 57.5511185,79.169749 C54.5619617,80.5675136 51.6096712,82.065772 48.5545983,83.2987478 C43.4123524,85.4799454 37.7903252,86.3624346 32.2067274,85.8650625 C29.1413631,85.5839675 26.1545513,84.7579325 23.3937564,83.4278607 C17.7098513,80.6544165 13.2670207,75.9403586 10.9088879,70.1807215 C9.1072651,65.9598539 8.17401666,61.434238 8.16216216,56.8618383 L8.16216216,49.6933287 L8.19889807,49.6861412 L8.19889807,43.7508688 C8.19030031,41.8336469 8.31053876,39.9178626 8.55883183,38.0161918 C8.98963203,34.4369682 10.0427281,30.955886 11.6726562,27.7223138 C13.7810629,23.4274808 17.1370577,19.8327061 21.3227369,17.3855725 C26.6545244,14.3316868 32.3609661,13.485919 38.4050655,14.2817667 C42.4633414,14.8310192 46.3939535,16.0605973 50.0233833,17.916007 C56.4444817,21.1493178 62.8516414,24.4210489 69.2711766,27.6959163 C69.2711766,27.6959163 69.3757827,27.7489728 69.3768249,27.7493648 C78.6415693,32.4751841 90.0607056,35.9631923 91.5908475,47.6575791 C91.750818,48.6361189 91.8317152,49.6185791 91.8378378,50.5967269 C91.8378378,50.9530941 91.830152,51.3020126 91.8162132,51.6436129",
    id: "Fill-1",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "doc-folder",
    transform: "translate(26.000000, 29.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39,13 L5,13 L5,2 C5,0.895 5.84527778,0 6.88888889,0 L13.5,0 L17.2777778,4 L36.1666667,4 C37.7316111,4 39,5.343 39,7 L39,13 Z",
    id: "Path",
    fill: "#6E6E6E",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41,19 L3,19 L3,8 C3,7.448 3.4256,7 3.95,7 L40.05,7 C40.5744,7 41,7.448 41,8 L41,19 Z",
    id: "Path",
    fill: "#CBCBCB",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5157021,39 L5.48429793,39 C4.5334143,39 3.72415165,38.3057143 3.57964046,37.3645714 L0.022738395,14.2217143 C-0.156455479,13.0539643 0.746257747,12 1.92739586,12 L42.0726041,12 C43.2537423,12 44.1564555,13.0539643 43.9772616,14.2217143 L40.4203595,37.3645714 C40.2748849,38.3057143 39.4665857,39 38.5157021,39 Z",
    id: "Path",
    fill: "#B2B2B1",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon/24pt/control/how",
    transform: "translate(12.000000, 16.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0168594,5 C12.6652756,5 14.1442584,7.68520745 12.8679229,9.40153155 L10.8784182,12.0666844 C10.5444397,12.4997884 9.88796368,12.6044541 9.41213789,12.3004617 C8.96430185,12.0143512 8.83609893,11.4682171 9.10100586,11.0438744 L9.17224982,10.943734 L10.8720665,8.66689117 L11.1245457,8.32742999 C11.4700311,7.86284598 10.9486234,6.91618993 10.0168594,6.91618993 C9.24426268,6.91618993 8.90785369,7.15401396 8.74529939,7.79704926 C8.61494291,8.31271585 8.05000282,8.63455937 7.4834704,8.51590687 C6.91693797,8.39725438 6.56334751,7.88303716 6.69370399,7.36737057 C7.07856779,5.84491927 8.2737306,5 10.0168594,5 Z M9.99699664,15 C10.5783329,15 11.049599,14.5710463 11.049599,14.041905 C11.049599,13.5127638 10.5783329,13.0838101 9.99699664,13.0838101 C9.41566042,13.0838101 8.94439429,13.5127638 8.94439429,14.041905 C8.94439429,14.5710463 9.41566042,15 9.99699664,15 Z",
    id: "Combined-Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,0 C4.4771525,0 0,4.4771525 0,10 C0,15.5228475 4.4771525,20 10,20 C15.5228475,20 20,15.5228475 20,10 C20,4.4771525 15.5228475,0 10,0 Z M10,2.5 C14.1421356,2.5 17.5,5.85786438 17.5,10 C17.5,14.1421356 14.1421356,17.5 10,17.5 C5.85786438,17.5 2.5,14.1421356 2.5,10 C2.5,5.85786438 5.85786438,2.5 10,2.5 Z",
    id: "Oval"
  }))))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconNoResults);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Icon-NoResults.34f43cd6e50cd4a1e89a9d7ec7b20d0b.svg";